import {
  SAVE_LEAD_SOURCE_LIST,
  SAVE_LEAD_SOURCE_DETAILS
} from 'redux/constants/LeadSources';

const theme = (state = {}, action) => {
  switch (action.type) {
  case SAVE_LEAD_SOURCE_LIST:
    return {
      ...state,
      list: action.payload
    };
  case SAVE_LEAD_SOURCE_DETAILS:
    return {
      ...state,
      details: action.payload
    };
  default:
    return state;
  }
};

export default theme